/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import BasicLayout from "../../layouts/BasicLayout";
import { products } from "../../constants/Products";
import Pagination from "../../components/Pagination";
import ModalPayFood from "../../components/ModalPayFood";

const filter = ["Tất cả", "Lẩu", "Chiên", "Nướng", "Xào", "Món khác"];

const Products = () => {
  const [filterIndex, setFilterIndex] = useState(0);
  const [toogleModeAddCart, setToogleModeAddCart] = useState(false);
  const [render, setRender] = useState(false);
  const [itemFood, setItemFood] = useState();
  const [dataFood, setDataFood] = useState({
    data: [],
    panigation: { pageSize: 1, page: 1 },
  });
  console.log(dataFood);

  const handleFilterFood = (index, name) => {
    setFilterIndex(index);
    if (name === "Tất cả") {
      setDataFood({
        panigation: {
          page: 1,
          pageSize: Math.ceil(
            products.data.length / products.panigation.perPage
          ),
        },
        data: products.data,
      });
      setRender(!render);
    } else if (name === "Món khác") {
      const filterData = products.data.filter((item) => {
        const nameFilter = item.name.toLowerCase();
        return (
          !nameFilter.includes("Lẩu".toLocaleLowerCase()) &&
          !nameFilter.includes("Chiên".toLocaleLowerCase()) &&
          !nameFilter.includes("Nướng".toLocaleLowerCase()) &&
          !nameFilter.includes("Xào".toLocaleLowerCase())
        );
      });
      setDataFood({
        panigation: {
          page: 1,
          pageSize: Math.ceil(filterData.length / products.panigation.perPage),
        },
        data: filterData,
      });
    } else {
      const filterData = products.data.filter((item) =>
        item.name.toLowerCase().includes(name.toLowerCase())
      );
      setDataFood({
        panigation: {
          page: 1,
          pageSize: Math.ceil(filterData.length / products.panigation.perPage),
        },
        data: filterData,
      });
    }
  };

  useEffect(() => {
    let arr = [];
    const rechangePage =
      products.panigation.perPage * dataFood.panigation.page >
      products.data.length
        ? products.data.length
        : products.panigation.perPage * dataFood.panigation.page;
    for (
      let index =
        dataFood.panigation.page * products.panigation.perPage -
        products.panigation.perPage;
      index < rechangePage;
      index++
    ) {
      arr.push(products.data[index]);
    }
    const pageSize = Math.ceil(
      products.data.length / products.panigation.perPage
    );
    setDataFood({
      panigation: { pageSize: pageSize, page: dataFood.panigation.page },
      data: arr,
    });
  }, [render]);

  return (
    <div id="filter" className="bg-[#f5f5f5] py-10">
      <div className="bg-[#ededed]">
        <BasicLayout>
          <div>
            <div className="flex sm:gap-4 gap-2 items-center flex-wrap p-3">
              <span className="font-semibold text-sm text-nowrap">Bộ lọc:</span>
              {filter.map((item, index) => {
                return (
                  <a
                    href="#filter"
                    onClick={() => handleFilterFood(index, item)}
                    style={
                      filterIndex === index
                        ? { backgroundColor: "#fc5a3a", color: "#fff" }
                        : null
                    }
                    key={item}
                    className="text-nowrap min-w-[85px] text-center px-2 py-[6px] font-semibold bg-white rounded cursor-pointer border border-primary"
                  >
                    {item}
                  </a>
                );
              })}
            </div>
          </div>
        </BasicLayout>
      </div>
      <BasicLayout>
        <div className="mt-3 grid grid-cols-12 gap-4">
          {dataFood?.data?.map((data, index) => {
            return (
              <div
                onClick={() => {
                  setItemFood(data);
                  setToogleModeAddCart(true);
                }}
                className="col-span-6 lg:col-span-3 md:col-span-4 bg-white hover:border hover:border-orange rounded cursor-pointer"
              >
                <div className="w-[100%] relative overflow-hidden">
                  <div className="pt-[100%]">
                    <img
                      className={`absolute top-0 left-0 bottom-0 right-0 w-full h-full object-fill rounded`}
                      src={data.img}
                    ></img>
                  </div>
                </div>
                <div className="px-2 pb-2">
                  <div className="text-[16px] font-medium p-[12px_8px_8px_2px] leading-5 hover:text-primary ellipsis-2 transition">
                    {data?.name || "demo bò xốt tiêu đen bánh bao"}
                  </div>
                  <div className="p-y[10px]">
                    <div className="flex gap-[6px] text-sm items-center">
                      <div className="text-xs">
                        <i class="fa-solid fa-star text-yellow"></i>
                        <i class="fa-solid fa-star text-yellow"></i>
                        <i class="fa-solid fa-star text-yellow"></i>
                        <i class="fa-solid fa-star text-yellow"></i>
                        <i class="fa-solid fa-star text-yellow"></i>
                      </div>
                      <span className="text-nowrap">Đã bán: </span>
                      <span>{data.quantity} </span>
                    </div>

                    <div className="mb-[5px] mt-2 mx-1 flex justify-between items-center">
                      <span className="font-16 text-red font-semibold">
                        {data.price.toLocaleString()}đ
                      </span>
                      <span className="text-right text-[#000000a6] text-xs">
                        Hải Dương
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Pagination
          pageSize={dataFood.panigation.pageSize}
          dataFood={dataFood}
          setDataFood={setDataFood}
          setRender={setRender}
          render={render}
        />
      </BasicLayout>
      <ModalPayFood
        setToogleModeAddCart={setToogleModeAddCart}
        toogleModeAddCart={toogleModeAddCart}
        data={itemFood}
      />
    </div>
  );
};

export default Products;
